import { EventActionType } from './event-action-type';

export interface AddEventOccurrenceAction {
  startsAt?: string;
  duration?: number;
  eventKey: string;
  type: EventActionType.AddOccurrence;
}

export const addEventOccurrence = (
  eventKey: string,
  startsAt?: string | Date,
  duration?: number,
): AddEventOccurrenceAction => ({
  duration,
  eventKey,
  startsAt: startsAt ? new Date(startsAt).toISOString() : undefined,
  type: EventActionType.AddOccurrence,
});
